var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVkGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6003 0.693636C16.7256 0.302727 16.6003 0.0181818 16.042 0.0181818H14.1871C13.7192 0.0181818 13.5036 0.267273 13.3774 0.533636C13.3774 0.533636 12.4227 2.81182 11.0904 4.28818C10.6583 4.71545 10.4605 4.85727 10.227 4.85727C10.1008 4.85727 9.93888 4.71545 9.93888 4.32364V0.676364C9.93888 0.212727 9.79482 0 9.39845 0H6.48157C6.19346 0 6.01361 0.213636 6.01361 0.427273C6.01361 0.872727 6.67931 0.979091 6.75178 2.22455V4.92909C6.75178 5.51636 6.64441 5.62273 6.40999 5.62273C5.77919 5.62273 4.24917 3.32727 3.33115 0.711818C3.14952 0.195455 2.97057 0 2.50261 0H0.629904C0.0903697 0 0 0.249091 0 0.516364C0 0.996364 0.629904 3.41636 2.93478 6.61909C4.4648 8.80818 6.64352 9.98273 8.6066 9.98273C9.79482 9.98273 9.93888 9.71546 9.93888 9.27091V7.61636C9.93888 7.08182 10.0462 6.99273 10.4247 6.99273C10.6949 6.99273 11.1808 7.13545 12.2795 8.18545C13.5393 9.43091 13.7559 10 14.4574 10H16.3122C16.8526 10 17.104 9.73273 16.96 9.21727C16.7989 8.70091 16.186 7.95364 15.3942 7.06364C14.962 6.56545 14.3133 6.01455 14.1156 5.74727C13.8454 5.39182 13.9178 5.24909 14.1156 4.92909C14.0977 4.92909 16.3659 1.76182 16.6003 0.693636Z",
    fill: "#A7ADB7",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkGrey);
export default __webpack_public_path__ + "static/media/vkGrey.f4ed11cea3b5eb0f25b8f5517e843125.svg";
export { ForwardRef as ReactComponent };